import type { TOC } from '@ember/component/template-only';

import GoalLogsTableRowComponent from 'webapp/components/goal/logs/table-row';
import SkeletonScreenComponent from 'webapp/components/skeleton-screen';

import GoalLog from 'webapp/models-custom/goal-log';

interface GoalLogsTableComponentInterface {
	Element: HTMLDivElement;
	Args: {
		isLoading: boolean;
		model: GoalLog[];
		extraClass?: string;
		selectedId: string | null;
		hideEdit?: boolean;
		edit?: (goalLog: GoalLog) => void;
	};
}

const GoalLogsTableComponent: TOC<GoalLogsTableComponentInterface> = <template>
	{{#if @isLoading}}
		<SkeletonScreenComponent @type="table" @itemCount={{3}} />
	{{else}}
		<table id="goal-logs-list" class="bigtable has-avatar {{@extraClass}}">
			<colgroup>
				<col />
				<col width="50%" />
				<col />
				{{#if @edit}}<col width="30" />{{/if}}
			</colgroup>
			<thead>
				<tr>
					<th>Status</th>
					<th>Note</th>
					<th>Value</th>
					{{#if @edit}}<th></th>{{/if}}
				</tr>
			</thead>
			<tbody>
				{{#each @model as |goalLog|}}
					<GoalLogsTableRowComponent
						@model={{goalLog}}
						@selectedId={{@selectedId}}
						@edit={{@edit}}
					/>
				{{/each}}
			</tbody>
		</table>
	{{/if}}
</template>;

export default GoalLogsTableComponent;
